/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mijn PiE BFF
 * OpenAPI spec version: 1.0
 */

export type MarketParticipantStatus = typeof MarketParticipantStatus[keyof typeof MarketParticipantStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarketParticipantStatus = {
  Active: 'Active',
  Inactive: 'Inactive',
  Blocked: 'Blocked',
  Ended: 'Ended',
  Qualification: 'Qualification',
  Cancelled: 'Cancelled',
} as const;
